module.exports = __webpack_public_path__ + "~@/assets/img/ipconfig_network.daabb5d9.png";